// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ov-0";